/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import Button from '@material-ui/core/Button';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import TextareaAutosize from '@material-ui/core/TextareaAutosize';
import Select from '@material-ui/core/Select';
import { withStyles } from '@material-ui/core';
import { UserAgent } from '@tmna-ct/ipapps-core-js';
import styles from './styles';
import { profileValues } from '../../constants/index';

class UserPorfileServices extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      setResponse: '',
      desireValue: '',
      setSelectedEvent: '',
      getSelectedEvent: '',
      getValue: '',
      appProperties: {},
    };
  }

  getHandler() {
    const { getSelectedEvent } = this.state;
    this.setState({
      getValue: UserAgent.getValue(getSelectedEvent),
    });
  }

  setHandler() {
    const { getSelectedEvent, desireValue } = this.state;
    UserAgent.setValue(getSelectedEvent, desireValue, e => {
      this.setState({ setResponse: typeof e !== 'undefined' ? e.error : 'Success at setting' });
    });
  }

  getPropHandler() {
    this.setState({ appProperties: UserAgent.properties });
  }

  render() {
    const {
      t,
      classes: { container, mainBody, mainActions, separation, bodySeparation, textArea },
    } = this.props;
    const { properties } = profileValues;
    const { getSelectedEvent, getValue, setResponse, appProperties} = this.state;
    return (
      <div className={container}>
        <h3 className={separation}>{t('screens.UserProfile.title')}</h3>
        <div className={mainActions}>
          <div className={bodySeparation}>
            <p>{t('screens.UserProfile.subtitle')}</p>
            <ButtonGroup className={separation} size="small" color="primary">
              <Button onClick={() => this.getHandler()}>{t('screens.UserProfile.get')}</Button>
              <Button onClick={() => this.setHandler()}>{t('screens.UserProfile.set')}</Button>
              <Button onClick={() => this.getPropHandler()}>
                {t('screens.UserProfile.getProps')}
              </Button>
            </ButtonGroup>
          </div>
        </div>
        <div className={mainBody}>
          <div className={bodySeparation}>
            <p>{t('screens.UserProfile.getDescription')}</p>
            <Select
              native
              value={getSelectedEvent}
              onChange={event =>
                this.setState({ getValue: '', getSelectedEvent: event.target.value })
              }
            >
              <option value="" />
              {properties.map(event => (
                <option key={event} value={event}>
                  {event}
                </option>
              ))}
            </Select>
            <span className={textArea}>Properties:</span>
            <TextareaAutosize
              id="value-name"
              label="Response:"
              disabled
              className={textArea}
              value={`${UserAgent.app_id}: ${JSON.stringify(appProperties, null, 2)}`}
              margin="normal"
            />
            <span className={textArea}>Get Response:</span>
            <TextareaAutosize
              id="value-name"
              label="Response:"
              disabled
              className={textArea}
              value={getValue}
              margin="normal"
            />
            <span className={textArea}>Value to be set:</span>
            <TextareaAutosize
              id="value-name"
              label="Value to be set:"
              className={textArea}
              margin="normal"
              onChange={event => {
                this.setState({ setResponse: '', desireValue: event.target.value });
              }}
            />
            {setResponse !== '' ?
              (
                <React.Fragment>
                  <span className={textArea}>Set Response:</span>
                  <span className={textArea}>{setResponse}</span>
                </React.Fragment>
              ):
              null
            }
          </div>
        </div>
      </div>
    );
  }
}

UserPorfileServices.propTypes = {
  t: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
};

export default withTranslation()(withStyles(styles)(UserPorfileServices));
